import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { razorPayKey } from '../../config/razorPay';
import TrvTo from '../../../assets/images/trvto-logo.png';
import { useNavigate } from 'react-router-dom';

const Payment = forwardRef(({ options: userOptions, paymentType, paymentData, setLoading, setChangeLoading }, ref) => {
    const navigate = useNavigate();

    const paymentHandler = (userOptions) => {
        const options = {
            ...userOptions
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };

    useImperativeHandle(ref, () => ({
        initiatePayment: () => {
            const options = {
                key: razorPayKey,
                currency: 'INR',
                amount: userOptions.amount,
                name: userOptions.name,
                description: userOptions.description,
                image: TrvTo,
                order_id: paymentData.orderId,

                method: paymentType === 'UPI' && {
                    upi: true,
                    card: false,
                    netbanking: false,
                    wallet: false,
                    paylater: false,
                    emi: false
                },

                handler: async function () {
                    // Success handler (optional)
                    setLoading(true);
                    clearTimeout(window.paymentTimeout);
                    const currentPath = window.location.pathname;
                    if (currentPath !== '/h/booking-confirmation') {
                        navigate('/h/payment-verification');
                    }
                },

                modal: {
                    ondismiss: function () {
                        // User closed payment manually
                        clearTimeout(window.paymentTimeout);
                    }
                },

                redirect: true,

                prefill: {
                    name: userOptions.prefill.name,
                    email: userOptions.prefill.email,
                    contact: userOptions.prefill.contact
                }
            };

            paymentHandler(options);
        }
    }));

    // Load Razorpay script
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    // useEffect(() => {
    //     const onFocus = () => {
    //         const currentPath = window.location.pathname;
    //         if (currentPath !== '/booking-confirmation') {
    //             navigate('/payment-verification');
    //         }
    //     };

    //     window.addEventListener('focus', onFocus);

    //     return () => {
    //         window.removeEventListener('focus', onFocus);
    //     };
    // }, [navigate]);

    return null;
});

export default Payment;
